<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-30">
        <div class="full-control">
          <div class="list">
            <v-list>
              <!-- If there is no draggable to display -->
              <h5
                v-if="!cat || !cat.length"
                class="text-center"
                style="font-style: italic"
              >
                Aucun draggable n'est actuellement disponible pour cette destination.
              </h5>
              <!-- else display the available draggables -->
              <v-list-group sub-group value="true" class="listgroup" v-for="list in cat" :key="list.id">
                <template v-slot:activator>
                  <v-list-item-title>{{ list.name }}</v-list-item-title>
                </template>

                <v-list-item v-for="item in list.draggables" :key="item.key" id="images">
                  <img
                    draggable="true"
                    @dragstart="dragstart($event)"
                    :id="item.id"
                    :name="item.name"
                    :src="item.image || require('@/assets/placeholder.jpg')"
                    class="draggable"
                    @click="select(item)"
                  />
                </v-list-item>
              </v-list-group>
            </v-list>
          </div>
        </div>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-70">
        <v-toolbar style="color: white" color="#0C1343">
          <v-btn-toggle v-model="toggle">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-model="isUnbind" v-on="on" @click="unbindCanvas(canvas)" text icon>
                  <v-icon>mdi-cursor-default</v-icon>
                </v-btn>
              </template>
              <span>Mode séléction</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-model="isPanning" v-on="on" @click="modePanning(canvas)" text icon>
                  <v-icon>mdi-hand</v-icon>
                </v-btn>
              </template>
              <span>Mode déplacement</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn @click="deleteElement()" v-on="on" text icon color="white" :disabled="!selectedCanvasObject">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Suppression</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn @click="flip()" v-on="on" text icon color="white" :disabled="!selectedCanvasObject">
                  <v-icon>mdi-swap-horizontal</v-icon>
                </v-btn>
              </template>
              <span>Flip</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn @click="bringForward()" v-on="on" text icon color="white" :disabled="!selectedCanvasObject">
                  <v-icon>mdi-arrange-bring-forward</v-icon>
                </v-btn>
              </template>
              <span>Avancer d'un plan</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn @click="sendBackwards()" v-on="on" text icon color="white" :disabled="!selectedCanvasObject">
                  <v-icon>mdi-arrange-send-backward</v-icon>
                </v-btn>
              </template>
              <span>Reculer d'un plan</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn @click="bringToFront()" v-on="on" text icon color="white" :disabled="!selectedCanvasObject">
                  <v-icon>mdi-arrange-bring-to-front</v-icon>
                </v-btn>
              </template>
              <span>Mettre au premier plan</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn @click="sendToBack()" v-on="on" text icon color="white" :disabled="!selectedCanvasObject">
                  <v-icon>mdi-arrange-send-to-back</v-icon>
                </v-btn>
              </template>
              <span>Mettre à l'arriére plan</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-model="isDrawing" v-on="on" @click="modeDrawing()" text icon>
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Mode dessin libre</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-model="isText" @click="modeText()" v-on="on" text icon>
                  <v-icon>mdi-format-text</v-icon>
                </v-btn>
              </template>
              <span>Mode texte</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-model="isArrow" @click="modeArrow()" v-on="on" text icon>
                  <v-icon>mdi-arrow-bottom-left</v-icon>
                </v-btn>
              </template>
              <span>Mode fléche</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-model="isCircle" @click="modeCircle()" v-on="on" text icon>
                  <v-icon>mdi-shape-circle-plus</v-icon>
                </v-btn>
              </template>
              <span>Mode cercle</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-model="isSquare" @click="modeSquare()" v-on="on" text icon>
                  <v-icon>mdi-shape-square-plus</v-icon>
                </v-btn>
              </template>
              <span>Mode rectangle</span>
            </v-tooltip>
          </v-btn-toggle>

          <template #extension>
            <v-toolbar-items class="mb-2">
              <v-btn-toggle class="mr-2">
                <v-menu md-size="auto" absolute v-model="showContour" :close-on-content-click="false" v-if="isDrawing || selectedCanvasObject">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      :style="{
                        'background-color': colors,
                      }"
                    >
                      <span style="z-index: auto; color: white; mix-blend-mode: difference"> Contour </span>
                    </v-btn>
                  </template>

                  <v-color-picker v-model="colors" v-on:update:color="handleStrokeColorChange" />
                </v-menu>

                <v-menu absolute v-model="showFond" :close-on-content-click="false" v-if="isDrawing || selectedCanvasObject">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      :style="{
                        'background-color': fillColors,
                      }"
                    >
                      <span style="z-index: auto; color: white; mix-blend-mode: difference"> Fond </span>
                    </v-btn>
                  </template>

                  <v-color-picker v-model="fillColors" v-on:update:color="handleFillColorChange" />
                </v-menu>
              </v-btn-toggle>

              <v-btn-toggle multiple v-if="isArrow">
                <v-btn v-model="isArrowEnd" text icon>
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>

                <v-btn v-model="isArrowStart" text icon>
                  <v-icon>mdi-arrow-right</v-icon>
                </v-btn>
              </v-btn-toggle>
            </v-toolbar-items>
          </template>
        </v-toolbar>

        <div id="canvas-container" @drop="handleDrop($event)">
          <canvas id="canvas" width="1280" height="720" v-on:keyup.delete="deleteElement()"></canvas>
          <p style="position: absolute; top: 0; right: 0">Zoom: {{ zoom }}%</p>
        </div>
      </div>
    </div>

    <div :mode="arrowHeads" />
  </div>
</template>
<script>
import AuthService from "@/services/AuthService";

import { bus } from "@/main.js";
import { fabric } from "fabric";

import Arrow from "./Canvas/Arrow";
import Square from "./Canvas/Square";
import Circle from "./Canvas/Circle";
import TextBox from "./Canvas/TextBox";

import {
  getAllDraggablesCategoriesAndRelatedDraggablesForDisciplineAsync,
  getAllDraggablesCategoriesAndRelatedDraggablesForFederationAsync,
  getAllDraggablesCategoriesAndRelatedDraggablesAvailableForDisciplineAsync,
  getDraggableStringUrl,
} from "@/api/draggablesApi";

export default {
  props: {
    load: Object,
    exerciseId: String,
    exerciseDraggables: Array,
    selectedFederationId: String,
    selectedDisciplineId: String,
  },

  data() {
    return {
      draggables: [],
      fileList: null,
      toggle: 0,
      image: null,
      result: null,
      cat: [],
      canvas: null,
      arrow: null,
      isUnbind: true,
      isArrow: false,
      isDrawing: false,
      isText: false,
      isCircle: false,
      isSquare: false,
      isPanning: false,
      objectInst: null,
      hasFill: true,
      hasColor: true,
      circle: null,
      square: null,
      isArrowStart: false,
      isArrowEnd: false,
      colors: "#000000ff",
      fillColors: "#ffffffff",
      width: 1,
      expandSingle: true,
      currentlyDragging: null,
      length: 1,
      tab: null,
      showContour: false,
      showFond: false,
      selectedCanvasObject: null,
    };
  },

  watch: {
    length(val) {
      this.tab = val - 1;
    },

    "load.disciplineId": async function () {
      this.cat = await this.loadImage();
    },
  },

  created() {
    bus.$on("beforeSaveExercise", () => {
      const draggables = [];
      // this.canvas.setZoom(0.5);
      this.keepPositionInBounds();

      this.canvas.getObjects().forEach((object, index) => {
        const draggable = {
          id: object.id,
          exerciseId: this.exerciseId,
          leftValue: object.left,
          topValue: object.top,
          isFlipped: object.flipX,
          width: object.width * object.scaleX,
          height: object.height * object.scaleY,
          rotationAngle: object.angle || 0,
          strokeThickness: null,
          fillColor: null,
          strokeColor: null,
          zindex: index,
          text: object.text,
          x1: object.x1,
          x2: object.y1,
          y1: object.x2,
          y2: object.y2,
        };

        if (object.heads) {
          draggable.hasStartHead = object.heads[0];
          draggable.hasEndHead = object.heads[1];
        }

        if (!object.draggableId) {
          draggable.data = object.toSVG();
          draggable.typeName = object.type;
        } else {
          draggable.draggableId = object.draggableId;
        }

        draggables.push(draggable);
      });

      this.load.exerciseDraggables = draggables;

      this.savePreview();
    });

    bus.$on("tabChange", () => {
      this.savePreview();
    });
  },

  computed: {
    draggablesToString: function () {
      return JSON.stringify(this.draggables);
    },

    zoom: function () {
      if (this.canvas) return (this.canvas.getZoom() * 100).toFixed();
      return null;
    },

    arrowHeads: function () {
      if (this.canvas == null) return null;

      if (this.objectInst != null) this.objectInst.heads = [this.isArrowStart, this.isArrowEnd];
      if (typeof this.canvas.getActiveObject() !== "undefined" && this.canvas.getActiveObject() != null) {
        this.canvas.getActiveObject().set("heads", [this.isArrowStart, this.isArrowEnd]);
      }
      return [this.isArrowStart, this.isArrowEnd];
    },
  },

  async mounted() {
    this.cat = await this.loadImage();

    // Extended fabric line class
    fabric.LineArrow = fabric.util.createClass(fabric.Line, {
      type: "lineArrow",

      initialize: function (element, options) {
        options || (options = {});
        this.callSuper("initialize", element, options);
      },

      toObject: function () {
        return fabric.util.object.extend(this.callSuper("toObject"));
      },

      _render: function (ctx) {
        this.ctx = ctx;
        this.callSuper("_render", ctx);
        let p = this.calcLinePoints();
        let xDiff = this.x2 - this.x1;
        let yDiff = this.y2 - this.y1;
        let angle = Math.atan2(yDiff, xDiff);
        this.drawArrow(angle, p.x2, p.y2, this.heads[0]);

        // ctx.save();
        xDiff = -this.x2 + this.x1;
        yDiff = -this.y2 + this.y1;
        angle = Math.atan2(yDiff, xDiff);
        this.drawArrow(angle, p.x1, p.y1, this.heads[1]);
      },

      drawArrow: function (angle, xPos, yPos, head) {
        this.ctx.save();

        if (head) {
          this.ctx.translate(xPos, yPos);
          this.ctx.rotate(angle);
          this.ctx.beginPath();
          // Move 5px in front of line to start the arrow so it does not have the square line end showing in front (0,0)
          this.ctx.moveTo(10, 0);
          this.ctx.lineTo(-15, 15);
          this.ctx.lineTo(-15, -15);
          this.ctx.closePath();
        }

        this.ctx.fillStyle = this.stroke;
        this.ctx.fill();
        this.ctx.restore();
      },
    });

    fabric.LineArrow.fromObject = function (object, callback) {
      callback && callback(new fabric.LineArrow([object.x1, object.y1, object.x2, object.y2], object));
    };

    fabric.LineArrow.async = true;

    //set new fabric canvas with div id
    var canvas = new fabric.Canvas("canvas");
    var currentlyDragging = this.currentlyDragging;

    var handleDragOver = function (e) {
      if (e.preventDefault) {
        e.preventDefault(); // Necessary. Allows us to drop.
      }

      e.dataTransfer.dropEffect = "copy"; // See the section on the DataTransfer object.

      return false;
    };

    var handleDragEnter = function () {
      // this / e.target is the current hover target.
      this.classList.add("over");
    };

    var handleDragLeave = function () {
      this.classList.remove("over"); // this / e.target is previous target element.
    };

    canvas.on("selection:created", this.handleSelect);
    canvas.on("selection:updated", this.handleSelect);
    canvas.on("selection:cleared", this.handleClearSelect);
    canvas.on("mouse:wheel", (opt) => {
      console.log("zoom");
      var delta = opt.e.deltaY;
      // var pointer = canvas.getPointer(opt.e);
      var zoom = canvas.getZoom();
      zoom = zoom + (delta * -1) / 200;
      if (zoom > 3) zoom = 3;
      if (zoom < 0.5) zoom = 0.5;
      canvas.zoomToPoint(
        {
          x: opt.e.offsetX,
          y: opt.e.offsetY,
        },
        zoom
      );
      opt.e.preventDefault();
      opt.e.stopPropagation();
      this.keepPositionInBounds();
    });

    // Bind the event listeners for the canvas
    var canvasContainer = document.getElementById("canvas-container");
    canvasContainer.addEventListener("dragenter", handleDragEnter, false);
    canvasContainer.addEventListener("dragover", handleDragOver, false);
    canvasContainer.addEventListener("dragleave", handleDragLeave, false);

    window.addEventListener("keydown", (event) => {
      var key = event.which || event.keyCode || event.charCode;

      if (key == 8) this.deleteElement();
    });

    this.canvas = canvas;
    this.currentlyDragging = currentlyDragging;

    // Load existing draggables related to exercise
    this.exerciseDraggables &&
      this.exerciseDraggables.forEach((draggable, index) => {
        if (!draggable.draggable && draggable.data) {
          fabric.loadSVGFromString(draggable.data, (objects, options) => {
            let svg = null;

            if (draggable.typeName === "lineArrow") {
              console.log(draggable.hasStartHead, draggable.hasEndHead, draggable.id);
              svg = new fabric.LineArrow([draggable.x1, draggable.x2, draggable.y1, draggable.y2], {
                type: "lineArrow",
                lockScalingFlip: true,
                heads: [draggable.hasStartHead, draggable.hasEndHead],
                fill: objects[0].fill,
                stroke: objects[0].stroke,
                strokeWidth: objects[0].strokeWidth,
                ...options,
              });
            } else {
              svg = fabric.util.groupSVGElements(objects, {
                originX: "left",
                originY: "top",
                left: draggable.leftValue,
                right: draggable.rightValue,
                flipX: draggable.isFlipped,
                lockScalingFlip: true,
                ...options,
              });
            }

            if (draggable.typeName === "circle" || draggable.typeName === "lineArrow") {
              svg.originX = "center";
              svg.originY = "center";
            }

            if (draggable.typeName !== "textbox" && draggable.typeName !== "lineArrow") {
              svg.scaleX = draggable.width / svg.width;
              svg.scaleY = draggable.height / svg.height;
            } else if (draggable.typeName == "lineArrow") {
              svg.width = draggable.width;
              svg.height = draggable.height;
            }

            svg.id = draggable.id;
            svg.left = draggable.leftValue;
            svg.top = draggable.topValue;
            svg.isFlipped = draggable.isFlipped;
            svg.flipX = draggable.isFlipped;
            svg.angle = draggable.rotationAngle;

            this.canvas.add(svg);
            this.canvas.moveTo(svg, index);
          });
        } else if (draggable.draggable) {
          const path = getDraggableStringUrl(draggable.draggable.path);

          fabric.loadSVGFromURL(path, (objects, options) => {
            var svg = fabric.util.groupSVGElements(objects, {
              originX: "left",
              originY: "top",
              left: draggable.leftValue,
              right: draggable.rightValue,
              flipX: draggable.isFlipped,
              lockScalingFlip: true,
              ...options,
            });

            const scaleX = draggable.width / svg.width;
            const scaleY = draggable.height / svg.height;

            svg.name = draggable.draggable.name;
            svg.draggableId = draggable.draggable.id;
            svg.id = draggable.id;
            svg.left = draggable.leftValue;
            svg.top = draggable.topValue;
            svg.scaleX = scaleX;
            svg.scaleY = scaleY;
            svg.isFlipped = draggable.isFlipped;
            svg.flipX = draggable.isFlipped;
            svg.angle = draggable.rotationAngle;

            this.canvas.add(svg);
            this.canvas.moveTo(svg, index);
          });
        }
      });
  },

  methods: {
    handleStrokeColorChange(e) {
      this.changeColor(e, "stroke");
    },

    handleFillColorChange(e) {
      this.changeColor(e, "fill");
    },

    changeColor(e, type) {
      const { hexa } = e;

      if (this.objectInst != null) {
        this.objectInst.fillColor = hexa;
      }

      var canvas = this.canvas;
      var selection = canvas.getActiveObject();

      if (selection.type === "activeSelection") {
        selection.forEachObject(function (element) {
          element.set(type, hexa);
        });
      } else {
        selection.set(type, hexa);
      }

      this.canvas.renderAll();
    },

    keepPositionInBounds() {
      var width = 2560,
        height = 1440;
      var zoom = this.canvas.getZoom();
      var vpt = this.canvas.viewportTransform;
      if (zoom < 0.4) {
        this.canvas.viewportTransform[4] = 200 - (width * zoom) / 2;
        this.canvas.viewportTransform[5] = 200 - (height * zoom) / 2;
      } else {
        if (vpt[4] >= 0) {
          this.canvas.viewportTransform[4] = 0;
        } else if (vpt[4] < this.canvas.getWidth() - width * zoom) {
          this.canvas.viewportTransform[4] = this.canvas.getWidth() - width * zoom;
        }
        if (vpt[5] >= 0) {
          this.canvas.viewportTransform[5] = 0;
        } else if (vpt[5] < this.canvas.getHeight() - height * zoom) {
          this.canvas.viewportTransform[5] = this.canvas.getHeight() - height * zoom;
        }
      }
    },

    unbindCanvas(canvas) {
      canvas.discardActiveObject().renderAll();
      canvas.isDrawingMode = false;

      canvas.selection = true;
      canvas.forEachObject(function (o) {
        o.selectable = true;
      });

      this.isUnbind = true;
      this.isArrow = false;
      this.isDrawing = false;
      this.isCircle = false;
      this.isSquare = false;
      this.isPanning = false;
      this.objectInst = null;
      canvas.off("mouse:down");
      canvas.off("mouse:move");
      canvas.off("mouse:up");
      canvas.forEachObject(function (o) {
        o.setCoords();
      });
    },

    modeText() {
      this.unbindCanvas(this.canvas);
      this.isUnbind = false;
      this.isDrawing = true;

      this.canvas.selection = false;
      this.canvas.forEachObject(function (o) {
        o.selectable = false;
      });

      this.isText = true;
      this.objectInst = new TextBox(this.canvas, this.fillColors);
    },

    modeArrow() {
      this.unbindCanvas(this.canvas);
      this.canvas.selection = false;

      this.canvas.selection = false;
      this.canvas.forEachObject(function (o) {
        o.selectable = false;
      });

      this.isUnbind = false;
      this.isArrow = true;
      this.objectInst = new Arrow(this.canvas, null, this.colors);
      this.objectInst.heads = this.arrowHeads;
    },

    modeDrawing() {
      this.unbindCanvas(this.canvas);
      this.isUnbind = false;
      this.isDrawing = true;
      this.canvas.isDrawingMode = true;

      this.canvas.selection = false;
      this.canvas.forEachObject(function (o) {
        o.selectable = false;
      });
    },

    modeCircle() {
      this.unbindCanvas(this.canvas);

      this.canvas.selection = false;
      this.canvas.forEachObject(function (o) {
        o.selectable = false;
      });

      this.isUnbind = false;
      this.Circle = true;
      this.objectInst = new Circle(this.canvas, this.colors);
    },

    modeSquare() {
      this.unbindCanvas(this.canvas);

      this.canvas.selection = false;
      this.canvas.forEachObject(function (o) {
        o.selectable = false;
      });

      this.isUnbind = false;
      this.isSquare = true;
      this.objectInst = new Square(this.canvas, this.fillColors, this.colors);
    },

    modePanning() {
      this.unbindCanvas(this.canvas);

      this.canvas.selection = false;
      this.canvas.forEachObject(function (o) {
        o.selectable = false;
      });

      this.isUnbind = false;
      this.isPanning = true;
      this.canvas.on("mouse:down", (opt) => {
        var evt = opt.e;
        this.canvas.isDragging = true;
        this.canvas.lastPosX = evt.clientX;
        this.canvas.lastPosY = evt.clientY;
        this.canvas.defaultCursor = "grabbing";
      });

      this.canvas.on("mouse:move", (opt) => {
        if (this.canvas.isDragging) {
          var e = opt.e;
          this.canvas.viewportTransform[4] += e.clientX - this.canvas.lastPosX;
          this.canvas.viewportTransform[5] += e.clientY - this.canvas.lastPosY;
          this.keepPositionInBounds();
          this.canvas.requestRenderAll();
          this.canvas.lastPosX = e.clientX;
          this.canvas.lastPosY = e.clientY;
        }
      });
      this.canvas.on("mouse:up", (opt) => {
        this.canvas.isDragging = false;
        this.canvas.defaultCursor = "auto";
      });
    },

    deleteElement() {
      var canvas = this.canvas;
      var selection = canvas.getActiveObject();

      if (selection && selection.type === "activeSelection") {
        selection.forEachObject(function (element) {
          canvas.remove(element);
        });
      } else {
        canvas.remove(selection);
      }

      canvas.discardActiveObject();
      canvas.requestRenderAll();
    },

    bringForward() {
      var canvas = this.canvas;
      var selection = canvas.getActiveObject();
      if (selection.type === "activeSelection") {
        selection.forEachObject(function (element) {
          canvas.bringForward(element);
        });
      } else {
        canvas.bringForward(selection);
      }
      canvas.requestRenderAll();
    },

    sendBackwards() {
      var canvas = this.canvas;
      var selection = canvas.getActiveObject();
      if (selection.type === "activeSelection") {
        selection.forEachObject(function (element) {
          canvas.sendBackwards(element);
        });
      } else {
        canvas.sendBackwards(selection);
      }
      canvas.requestRenderAll();
    },

    sendToBack() {
      var canvas = this.canvas;
      var selection = canvas.getActiveObject();
      if (selection.type === "activeSelection") {
        selection.forEachObject(function (element) {
          canvas.sendToBack(element);
        });
      } else {
        canvas.sendToBack(selection);
      }
      canvas.requestRenderAll();
    },

    bringToFront() {
      var canvas = this.canvas;
      var selection = canvas.getActiveObject();
      if (selection.type === "activeSelection") {
        selection.forEachObject(function (element) {
          canvas.bringToFront(element);
        });
      } else {
        canvas.bringToFront(selection);
      }
      canvas.requestRenderAll();
    },

    flip() {
      var canvas = this.canvas;
      var selection = canvas.getActiveObject();
      if (selection.type === "activeSelection") {
        selection.forEachObject(function (element) {
          element.flipX = !element.flipX;
        });
      } else {
        selection.flipX = !selection.flipX;
      }
      canvas.requestRenderAll();
    },

    savePreview() {
      if (this.canvas.getObjects().length > 0 && this.canvas) {
        this.load.preview = this.canvas.toDataURL({ format: "PNG" });
      } else {
        delete this.load.preview;
      }
    },

    handleSelect(event) {
      const { selected } = event;

      this.selectedCanvasObject = selected;

      if (selected.length === 1) {
        const [item] = selected;
        this.colors = this.rgbaToHex(item.stroke);
        this.fillColors = this.rgbaToHex(item.fill);
      }
    },

    rgbaToHex(rgba) {
      if (!rgba) return;

      const searches = rgba.replace(/\s/g, "").match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i);
      const alpha = ((searches && searches[4]) || "").trim();

      if (!searches) return rgba.length === 7 ? `${rgba}ff` : rgba;

      const r = (searches[1] | (1 << 8)).toString(16).slice(1);
      const g = (searches[2] | (1 << 8)).toString(16).slice(1);
      const b = (searches[3] | (1 << 8)).toString(16).slice(1);

      let a = alpha !== "" ? alpha : 1;
      a = ((a * 255) | (1 << 8)).toString(16).slice(1);

      return `#${r}${g}${b}${a}`;
    },

    handleClearSelect() {
      this.selectedCanvasObject = null;
    },

    async loadImage() {
      let fedId = this.load.federationId != null ? this.load.federationId : this.load.defaultFederationId;

      let cat;

      if (this.load.disciplineId) {
        cat = await getAllDraggablesCategoriesAndRelatedDraggablesAvailableForDisciplineAsync(this.load.disciplineId);
      } else {
        cat = await getAllDraggablesCategoriesAndRelatedDraggablesForFederationAsync(fedId);
      }

      for (let y = 0; y < cat.length; y++) {
        let list = cat[y].draggables;
        for (let i = 0; i < list.length; i++) {
          const { path } = list[i];
          list[i].image = getDraggableStringUrl(path);
        }

        cat[y].draggables = list;
      }

      return cat;
    },

    dragstart(e) {
      this.currentlyDragging = e.target;
    },

    async handleDrop(e) {
      if (e.preventDefault) {
        e.preventDefault(); // Necessary. prevent bug in firefox.
      }

      const { currentlyDragging } = this;
      const ext = currentlyDragging.name.split(".");

      if (ext[ext.length - 1] === "svg") {
        fabric.loadSVGFromURL(currentlyDragging.src, (objects, options) => {
          const pointer = this.canvas.getPointer(e);

          const svg = fabric.util.groupSVGElements(objects, options);

          svg.id = 0;
          svg.draggableId = currentlyDragging.id;
          svg.name = currentlyDragging.name;
          svg.left = pointer.x;
          svg.top = pointer.y;
          svg.originX = "left";
          svg.originY = "top";
          svg.lockScalingFlip = true;

          svg.scaleToHeight(100);
          this.canvas.add(svg);
        });
      } else {
        fabric.Image.fromURL(
          currentlyDragging.src,
          (img) => {
            var myImg = img.set({
              left: e.layerX,
              top: e.layerY,
            });
            myImg.scaleToHeight(100);
            myImg.draggableId = currentlyDragging.id;
            this.canvas.add(myImg);
          },
          { crossOrigin: "Anonymous" }
        );
      }
    },
  },
};
</script>

<style lang="scss">
.full-control {
  max-height: 832px;
  overflow: scroll;
}

#canvas-container {
  position: relative;
  max-height: 720px;
  max-width: 1280px;
  height: 100%;
  width: 100%;
  box-shadow: 0 0 5px 1px black;
  margin: 10px auto;
  border: 5px solid transparent;
  overflow: hidden;
}

.toolbar {
  border: 1px solid rgb(255, 255, 255);
  padding: 4px;
  margin-bottom: 10px;
  background-color: #eee;
  font-family: sans-serif;
  font-size: 12px;
}

.toolbarRow {
  height: 54px;
}

.slider,
.toolbarRow {
  display: flex;
  flex-direction: row;
}

.btnGroup {
  position: relative;
}

.btnGroup .btnGroupElts,
.colorPickerRow {
  flex-direction: row;
  display: flex;
}

.iconBtn {
  width: 30px;
  height: 30px;
}

.draggable {
  max-width: 50px;
  max-height: 50px;
}

.internal-md-list {
  flex-flow: wrap !important;
  max-height: 300px;
}

#images .img_dragging {
  opacity: 0.4;
}

/* 
Styles below based on  http://www.html5rocks.com/en/tutorials/dnd/basics/ 
*/

/* Prevent the text contents of draggable elements from being selectable. */
[draggable] {
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  /* Required to make elements draggable in old WebKit */
  -khtml-user-drag: element;
  -webkit-user-drag: element;
  cursor: move;
}

input[type="checkbox"][id^="cb"] {
  display: none;
}

label {
  border: 1px solid #fff;

  display: block;
  position: relative;

  cursor: pointer;
}

label:before {
  background-color: white;
  color: white;
  content: " ";
  display: block;
  border-radius: 50%;
  border: 1px solid grey;
  position: absolute;
  top: -5px;
  left: -5px;
  width: 25px;
  height: 25px;
  text-align: center;
  line-height: 28px;
  transition-duration: 0.4s;
  transform: scale(0);
}

label img {
  transition-duration: 0.2s;
  transform-origin: 50% 50%;
}

:checked + label {
  border-color: #ddd;
}

.invertedSpan {
  z-index: auto;
  background: inherit;
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
  filter: invert(1) grayscale(1);
  -webkit-filter: invert(1) grayscale(1);
}

:checked + label img {
  transform: scale(0.9);
  box-shadow: 0 0 5px #333;
  z-index: -1;
}
#images {
  display: inline !important;
}
</style>
